/*
 * @Author: Teemo Ding
 * @Date: 2021-09-22 14:01:59
 * @LastEditTime: 2021-11-04 15:04:32
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Logistics/Components/Courier/index.tsx
 */

import { Select } from '@/src/components/Antd';
import { Form, Spin } from 'antd';
import { get } from 'lodash';
import React from 'react';

import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
import { getCourierShow } from '../../CourierAccount/tools';
import css from './css.module.less';

interface IProps {
  getCourierListLoading: boolean;
  courierList: any[];
  hideSpeed?: boolean;
}
const Courier = ({ getCourierListLoading, courierList, hideSpeed }: IProps) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const courierAccountList = courierList.map((item) => ({
    value: item.uuid,
    label: (
      <div>
        <div>{item.name || ''}</div>
        <span className={css.selectItemIntroduce}>{getCourierShow(item)}</span>
      </div>
    ),
  }));
  if (!hideSpeed)
    courierAccountList.push({
      label: <div>{getI18n('general.status.none')}</div>,
      value: null,
    });

  const shippingSpeedList = [
    { label: getI18n('general.status.none'), value: 'None' },
  ];

  return (
    <div className={css.itemBlock}>
      <div className={css.header}>
        <div className={css.title}>
          {getI18n('storeLogistics.warehouseLocations.courier')}
        </div>
      </div>
      <div className={`${css.itemContent} ${css.content}`}>
        <Spin spinning={getCourierListLoading}>
          <div className={css.courier}>
            <Form.Item
              initialValue={null}
              name='courierAccount'
              className={css.courierAccount}
              label={`${getI18n(
                'storeLogistics.warehouseLocations.courier',
              )}* `}>
              <Select size='large' optionsList={courierAccountList} />
            </Form.Item>
            {!hideSpeed && (
              <Form.Item
                noStyle
                shouldUpdate={(prevValues, currentValues) =>
                  get(prevValues, 'courierAccount', '') !==
                  get(currentValues, 'courierAccount', '')
                }>
                {({ getFieldValue }) =>
                  getFieldValue('courierAccount') && (
                    <Form.Item
                      name='shippingSpeed'
                      className={css.shippingSpeed}
                      label={`${getI18n(
                        'storeLogistics.warehouseLocations.shippingSpeed',
                      )}* `}
                      rules={[
                        {
                          required: true,
                          message: replaceI18nVariables(
                            getI18n('general.fieldisrequired'),
                            getI18n(
                              'storeLogistics.warehouseLocations.shippingSpeed',
                            ),
                          ),
                        },
                      ]}>
                      <Select size='large' optionsList={shippingSpeedList} />
                    </Form.Item>
                  )
                }
              </Form.Item>
            )}
          </div>
        </Spin>
      </div>
    </div>
  );
};

export default Courier;
